import type {TWaitingRoomResponse} from '@kapitalist/contract/endpoints'
import {endpoints} from '@kapitalist/contract/endpoints'
import type {TPathPiecesOf, TRequestOf} from '@kapitalist/contract/endpoints/types'
import type {TFormError} from '@kapitalist/contract/types'
import {PostApi} from '~/api/client'
import {playersMock} from '~/api/endpoints/game/GetGameData/mock'

const endpoint = endpoints.pregame.kickFromWaitingRoom

type Params = TRequestOf<typeof endpoint>
type PathPieces = TPathPiecesOf<typeof endpoint>

/**
 * The creator of a game lobby can kick a player from the joined list.
 */
export default class KickPlayerFromWaitingRoom extends PostApi<typeof endpoint>() {
  constructor() {
    super(endpoint)
  }

  protected mockRequestFailure(
    params: Params,
    pathPieces: PathPieces
  ): TFormError | null {
    if (pathPieces.gameId === 'fail') {
      return {errors: {gameId: [`That game doesn't exist.`]}}
    }

    // return super.mockRequestFailure(params, pathPieces)
    return null // TODO replace this with defaultMockRequestFailure if/once we bring that behavior in from MW
  }

  protected getMockResponse(
    params: Params,
    pathPieces: PathPieces
  ): TWaitingRoomResponse {
    return {
      gameId: pathPieces.gameId,
      status: 'waiting',
      players: playersMock.filter(p => p.playerId !== pathPieces.playerId),
      hostPlayerId: playersMock[0].playerId,
    }
  }

  protected transformResponse(r: TWaitingRoomResponse) {
    return r
  }
}
